export default "__VITE_ASSET__65aaec18__"